// extracted by mini-css-extract-plugin
export default {"imgDiv":"error_imgDiv__HgU99","errorImg":"error_errorImg__NecT5","btnDiv":"error_btnDiv__ioCjV","errorBtn":"error_errorBtn__ythJa"};